/* eslint-disable */
const HOST = `${window.location.protocol}//${window.location.host}`

export const keycloakStaticConfig = {
  scope: 'ns-scopes',
  redirectUri: `${HOST}/login/sso/code`,
  logoutUri: `${HOST}/login`,
  logoutCreatePasswordUri: `${HOST}/login/createPassword`,
}

// this object is used here to prevent constants minification by webpack. Without assigning constants to this object, webpack may precalculate some expressions with these constants during build phase and as result in such cases placeholders would be eliminated from code before replace_placeholders.sh execution.
export const DynamicConfigs = {
  keycloakEnabled: process.env.KEYCLOAK_ENABLED,
  grafanaEnabled: process.env.GRAFANA_ENABLED,
  appHost: process.env.APP_HOST,
  appWsEndpoint: process.env.APP_WS_ENDPOINT,
  keycloakDomain: process.env.KEYCLOAK_DOMAIN,
  keycloakRealm: process.env.KEYCLOAK_REALM,
  keycloak2Realm: process.env.KEYCLOAK_2_REALM,
  keycloak2UrlPrefix: process.env.KEYCLOAK_2_CONDITIONAL_DOMAIN_PREFIX
}


// WEBPACK FOOTER //
// ./src/app/dynamic-configs-exports.js